// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "9a83c914396a149f2cac86cc55b25b0d" + ".js";
};